import { Inject, Injectable } from '@angular/core';
import { QrCodeInterface } from './interfaces/qr-code-interface';
import { Observable, catchError, map, shareReplay, throwError } from 'rxjs';
import { ACTIVITIES_BASE_URL } from '~/core/core.module';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RedirectionService } from '~/core/services/redirection/redirection.service';

@Injectable({
  providedIn: 'root',
})
export class QrCodeService {
  constructor(
    @Inject(ACTIVITIES_BASE_URL) protected readonly activitiesUrl: string,
    protected readonly httpClient: HttpClient,
    private readonly redirectionService: RedirectionService
  ) {}

  public getQrCodes(timeslotIdentifier: string): Observable<QrCodeInterface[]> {
    const skuParam = new HttpParams().set('skus[]', timeslotIdentifier);
    return this.httpClient
      .get<QrCodeInterface[]>(`${this.activitiesUrl}/qr-codes`, {
        params: skuParam,
      })
      .pipe(map((qrCodedata) => qrCodedata));
  }

  public postQrCode(qrCodeId: string): Observable<{ qrCode: QrCodeInterface }> {
    return this.httpClient
      .post<QrCodeInterface>(
        `${this.activitiesUrl}/qr-codes/${qrCodeId}/scan`,
        {
          qrCodeId,
        }
      )
      .pipe(
        shareReplay(1),
        map((qrCode) => ({
          qrCode,
        })),
        catchError((error) => {
          if (error?.status === 403) {
            this.redirectionService.redirect(
              `/${'organizer.qr-code-validation.invalid'}`
            );
          } else {
            this.redirectionService.redirect(
              `/${'organizer.qr-code-validation.error'}`
            );
          }

          return throwError(() => error);
        })
      );
  }
}
